import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const bomItemIsRememberedPurchasingBoMItemSelector =
  (bomItemId: string) => (state: RootAppState) => {
    const bomItem = bomItemSelector(state, bomItemId)

    switch (bomItem?.type) {
      case 'Row': {
        return bomItem.isRememberedPurchasingBoMItem
      }
    }

    return false
  }
